<template lang="pug">
  v-container(fluid v-if="!isKioskMode")
    v-snackbar(v-model="showSnackBar" :timeout="5000" :color="snackbarColor")
      | {{ snackBarMessage }}
      v-btn(fab text @click="showSnackBar = false")
        v-icon fal fa-times-circle

    v-row(v-if="showMobileNavigationBar" no-gutters)
      v-col.pa-0(cols="12")
        v-btn(color="primary" @click="onBackToCalendarButtonClick")
          v-icon fa fa-chevron-double-left

    v-row
      v-col.pt-0(v-if="showCalendar " xs="12" sm="12" md="3" lg="3")
        Calendar.pa-0.ma-0(
          :isoWeek.sync="calendarIsoWeek" :menuOfferCollection="weeklyOfferCollection" @selected="selected"
          :reservationCollection="weeklyReservationCollection" :date="date"
        )

      v-col.pa-0.pb-0(v-if="showOfferContent" xs="12" sm="12" md="9" lg="9")
        div.header(v-if="!isKioskMode")
        div(v-else)
        TopGroup.pa-0(
          v-if="menuGroupItem && date && !fetchInProgress" :setFreeDay="setFreeDay" :getEventName="getEventName" :configuration="configuration"  :customerConfiguration="customerConfiguration"
          :menuGroupItem="menuGroupItem" :menuGroupList="menuGroupList" :date="date" :reservationItem="currentReservationItem" :settingsData="settingsData" :selectedMenu="selectedMenu"
          @newReservationCreated="onNewReservationCreated" @reservationChanged="onReservationChanged" @updateData="fetchWeeklyData" @refreshData="refreshData"
          @selectionChange="onGroupSelectionChange(menuGroupItem, ...arguments)"
        )
        v-skeleton-loader(v-else type="list-item-avatar-three-line, article, actions")
  v-container.ma-0.pa-0(v-else fluid)
    v-snackbar(v-model="showSnackBar" :timeout="5000" :color="snackbarColor")
      | {{ snackBarMessage }}
      v-btn(fab text @click="showSnackBar = false")
        v-icon fal fa-times-circle

    v-row.ma-0(no-gutters)
      v-col.pt-0(v-if="showCalendar" cols="4" sm="4" md="4" lg="3" xl="3")
        Calendar.pa-0.ma-0(
          :isoWeek.sync="calendarIsoWeek" :menuOfferCollection="weeklyOfferCollection" @selected="selected"
          :reservationCollection="weeklyReservationCollection" :date="date"
        )
        //v-col.pa-0.pb-0.style-col(cols="3" align="end" justify="end" )
        v-btn.style-col(color="error" @click="onOutLoggedUser" x-large height="50px" v-if="isKioskMode && isShowLogOutButtonMode")
          v-icon fas fa-sign-out
          span.text-h5.pl-2 {{ $t('toolbarPage.logoutLabel') }}

      v-col(v-if="showOfferContent" xs="8" sm="8" md="8" lg="9" xl="9")
        TopGroup.pa-0(
          v-if="menuGroupItem && date && !fetchInProgress" :setFreeDay="setFreeDay" :getEventName="getEventName" :configuration="configuration" :customerConfiguration="customerConfiguration"
          :menuGroupItem="menuGroupItem" :menuGroupList="menuGroupList" :date="date" :reservationItem="currentReservationItem" :settingsData="settingsData" :selectedMenu="selectedMenu"
          @newReservationCreated="onNewReservationCreated" @reservationChanged="onReservationChanged" @updateData="fetchWeeklyData" @refreshData="refreshData"
          @selectionChange="onGroupSelectionChange(menuGroupItem, ...arguments)"
        )
        v-skeleton-loader(v-else type="list-item-avatar-three-line, article, actions")

</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import vuetify from '@/plugins/vuetify'
import Calendar from '@/components/order/Calendar.vue'
import DailyMenuOffer from '@/model/DailyMenuOffer'
import TopGroup from '@/components/order/TopGroup.vue'
import {
  AUTH_LOG_USER_OUT,
  FETCH_CALENDAR_EVENTS_FOR_DAY,
  FETCH_CUSTOMER_DATA,
  FETCH_OFFER_RESERVATION,
  FETCH_STRUCTURED_MENU_OFFER, FETCH_TENANT_NAME
} from '@/store/action-types'
import {FetchOfferReservationPayload, FetchStructuredMenuOfferPayload, FilterEventsPayload} from '@/types/payload'
import {
  OfferReservationResponse, OfferReservationResponseItem,
  StructuredMenuOfferResponse,
  StructuredMenuOfferResponseItem
} from '@/types/service-response'
import MenuGroupItem from '@/model/MenuGroupItem'
import {formatAsIsoWeek} from '@/services/date-time'
import moment from 'moment'
import MenuReservationItem from '@/model/MenuReservationItem'
import {CurrentUser} from '@/model/CurrentUser'
import {GET_MODE, GET_SHOW_LOGOUT_BUTTON_MODE, USER_LOGGED_IN} from '@/store/getter-types'
import {TranslateResult} from 'vue-i18n'
import {SubGroupSelectionMap, TopGroupSelectionMap} from '@/types'
import {Route} from 'vue-router'
import {Component, Prop, Watch} from "vue-property-decorator";
import {Action} from "vuex-class";
import {CalendarEvent} from "vuetify";
import CalendarEventForDay from "@/model/CalendarEventForDay";
import Configuration from "@/model/Configuration";
import {usePiniaStore} from "@/store/piniaStore";

function redirectIfNeeded(to: Route, next: Function): void {
  try {
    const paramValueResolver: {
      [key: string]: Function
    } = {
      isoWeek: () => to.params.isoWeek || formatAsIsoWeek(new Date),
      date: () => to.params.date || moment().format('YYYY-MM-DD')
    }

    let paramsToCheck = ['isoWeek']

    if (vuetify.framework.breakpoint.mdAndUp) {
      paramsToCheck.push('date')
    }

    // kazdy z testovanych parametrov musi byt truethy inak every vrati false
    const redirect = !paramsToCheck.every((param: string) => to.params.hasOwnProperty(param))

    if (redirect) {
      const paramValues = paramsToCheck.map((param: string) => paramValueResolver[param] && paramValueResolver[param]())

      next({
        name: 'Order',
        replace: true,
        params: _.zipObject(paramsToCheck, paramValues)
      })

    } else {
      next()
    }
  } catch (e) {
  }
}

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
])

@Component({
  components: {
    Calendar,
    TopGroup,
  }
})
export default class OrderPage extends Vue {

  @Prop({type: Date}) readonly date!: Date
  @Prop({type: String, required: true}) isoWeek!: string

  @Action(FETCH_CALENDAR_EVENTS_FOR_DAY) fetchCalendarEventsForDay!: { (payload: FilterEventsPayload): Promise<CalendarEventForDay[]> }
  @Action(AUTH_LOG_USER_OUT) logUserOut!: { (): Promise<void> }

  private piniaStore: any = usePiniaStore()

  private menuGroupItem: MenuGroupItem | null = null
  private calendarIsoWeek: string = this.isoWeek
  private weeklyOfferCollection: DailyMenuOffer[] | null = null
  private weeklyReservationCollection: MenuReservationItem[] | null = null
  private showSnackBar: boolean = false
  private snackbarColor: string = ''
  private snackBarMessage: TranslateResult | null = null
  private currentSelection: TopGroupSelectionMap = new Map()
  private showChangeConfirmationDialog: boolean = false
  private menuGroupList: MenuGroupItem[] | null = null

  private fetchInProgress: boolean = false

  private events: CalendarEventForDay[] | null = null
  private setFreeDay: boolean = false
  private configuration: Configuration[] = []
  private settingsData: any[] = []
  private selectedMenu: string | null = null
  private isMoving: boolean = false
  private customersettingsData: any | null = null
  private customerConfiguration: any | null = null

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get isShowLogOutButtonMode (): boolean {
    return this.$store.getters[GET_SHOW_LOGOUT_BUTTON_MODE] === 'true'
  }


  get currentUser(): CurrentUser {
    return this.$store.getters[USER_LOGGED_IN]
  }

  get currentReservationItem(): MenuReservationItem[] | undefined {
    if (this.date && this.weeklyReservationCollection) {
      return this.weeklyReservationCollection.filter((item: MenuReservationItem) => moment(item.date).isSame(this.date, 'date'))
    }
  }

  get showMobileNavigationBar(): boolean {
    return this.$vuetify.breakpoint.smAndDown && this.showOfferContent
  }

  get showCalendar(): boolean {
    if (this.$vuetify.breakpoint.smAndDown) {
      return this.date === undefined
    }

    return true
  }

  get showOfferContent(): boolean {
    if (this.$vuetify.breakpoint.smAndDown) {
      return this.date !== undefined
    }

    return true
  }

  getCurrentEvent() {
      let localeIsoWeek = localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
    if (this.events) {

      const foundEvent: CalendarEvent | undefined = this.events!.find((item: CalendarEvent) => item.date === moment(this.date).locale('localeIsoWeek').format('YYYY-MM-DD'))
      this.setFreeDay = !!foundEvent
    }
  }

  get getEventName(): string {
    if (this.events) {
      const foundEvent: CalendarEventForDay | undefined = this.events!.find((item: CalendarEventForDay) => moment(item.date, 'YYYY-MM-DD').format('D.M.YYYY') === moment(this.date).format('D.M.YYYY'))
      if (foundEvent && foundEvent.kind.name == 'holiday') {
        return this.$t('orderPage.freeDayInformationText', {eventName: 'sú prázdniny'}).toString()
      } else if (foundEvent && foundEvent.kind.name == 'free_day') {
        return this.$t('orderPage.freeDayInformationText', {eventName: 'je voľno'}).toString()
      }
    }

    return ''
  }

  @Watch('isoWeek')
  watchIsoWeek(newVal: string): void {
    this.fetchWeeklyData(newVal)
  }

  @Watch('date')
  watchDate(newVal: Date): void {
    const dateOffer = this.findCachedOfferForDate(newVal)

    if (dateOffer) {
      // FIXME: predpoklada sa ze vzdy bude zobrazeny obed
      this.menuGroupItem = dateOffer.menuGroupList[0]
      this.menuGroupList = dateOffer.menuGroupList
    }

    if (this.events) {
      this.getCurrentEvent()
    }
  }

  @Watch('calendarIsoWeek')
  watchCalendarIsoWeek(newVal: string): void {
    if (newVal) {
      this.$router.push({
        name: 'Order',
        params: {
          isoWeek: newVal,
          date: this.date && moment(this.date).format('YYYY-MM-DD')
        }
      }).catch((e) => console.debug(e))
    }
  }

  @Watch('weeklyOfferCollection')
  watchWeeklyOfferCollection(newVal: DailyMenuOffer[] | undefined): void {
    if (newVal && newVal.length) {
      const currentDateOffer = this.findCachedOfferForDate(this.date as unknown as Date)

      if (currentDateOffer) {
        // FIXME: predpoklada sa ze vzdy bude zobrazeny obed
        this.menuGroupItem = currentDateOffer.menuGroupList[0]
        this.menuGroupList = currentDateOffer.menuGroupList
      }
    }
  }

  @Watch('showOfferContent')
  watchShowOfferContent(newVal: any): void {
      let localeIsoWeek = localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
    if (newVal && !this.date) {
      this.$router.replace({
        name: 'Order',
        params: {
          isoWeek: this.isoWeek,
          date: moment(this.isoWeek).startOf('isoWeek').locale('localeIsoWeek').format('YYYY-MM-DD')
        }
      }).catch((e) => console.debug(e))
    }
  }

  selected(item: any){
    this.selectedMenu = item
    this.$emit('selected',this.selectedMenu)
  }

  findCachedOfferForDate(date: Date): DailyMenuOffer | undefined {
    if (this.weeklyOfferCollection) {
      return this.weeklyOfferCollection.find((i: DailyMenuOffer) => moment(i.date).isSame(date, 'date'))
    }
  }

  onOutLoggedUser (){
    this.logUserOut()
    this.$router.push('/login')
  }

  async fetchEventsData(start: Date, end: Date): Promise<void> {

    let payload: FilterEventsPayload = {
      before: end,
      after: start
    }

    try {
      let response: CalendarEventForDay[] = await this.fetchCalendarEventsForDay(payload)
      this.events = response.map((e): CalendarEventForDay => ({
        id: e.id,
        kind: e.kind,
        date: moment(e.date).format('YYYY-MM-DD'),
      }))
    } catch (e) {
      this.showSnackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    } finally {
    }
  }

  async fetchWeeklyData(isoWeek: string): Promise<void> {

    this.fetchInProgress = true

    const startDate = moment(isoWeek).startOf('isoWeek').toDate()
    const endDate = moment(isoWeek).endOf('isoWeek').toDate()
    const businessId = this.currentUser.business.id

    const promises = [
      this.fetchWeeklyOffer(startDate, endDate, businessId),
      this.fetchWeeklyReservation(startDate, endDate),
      this.fetchEventsData(startDate, endDate)
    ]

    const [
      offerCollection,
      reservationCollection,
    ] = await Promise.all(promises as Promise<Object[]>[]) as [DailyMenuOffer[], MenuReservationItem[], CalendarEvent[]]

    this.weeklyOfferCollection = offerCollection
    this.weeklyReservationCollection = reservationCollection
    this.fixDateIfNeeded()
    this.fetchInProgress = false
  }

  async fetchWeeklyOffer(dateFrom: Date, dateTo: Date, businessId: Number): Promise<DailyMenuOffer[]> {
    this.weeklyOfferCollection = null

    const response: StructuredMenuOfferResponse = await this.$store.dispatch(FETCH_STRUCTURED_MENU_OFFER, {
      tenantCode: this.currentUser.tenant.code,
      dateFrom,
      dateTo,
      businessId,
    } as FetchStructuredMenuOfferPayload)

    return response
        .filter((item: StructuredMenuOfferResponseItem) => item.date )
        //.filter((item: StructuredMenuOfferResponseItem) => isDateAfterDeadline(new Date, moment(item.date).toDate()))
        .map((item: StructuredMenuOfferResponseItem) => DailyMenuOffer.createFromResponse(item))
  }

  refreshData(item: any){
    let foundItem: MenuReservationItem | undefined = this.weeklyReservationCollection?.find((i: MenuReservationItem) => i.id === item.id)
    if(foundItem){
      let index: number = this.weeklyReservationCollection!.indexOf(foundItem)
      if (index !== -1) {
        this.weeklyReservationCollection!.splice(index, 1, MenuReservationItem.createFromResponse(item))
      }
    }
  }

  async fetchWeeklyReservation(dateFrom: Date, dateTo: Date): Promise<MenuReservationItem[]> {
    this.weeklyReservationCollection = null

    const response: OfferReservationResponse = await this.$store.dispatch(FETCH_OFFER_RESERVATION, {
      tenantCode: this.currentUser.tenant.code,
      dateFrom,
      dateTo,
      boarderId: this.currentUser.getBoarder.id
    } as FetchOfferReservationPayload)

    return response.map((item: OfferReservationResponseItem) => MenuReservationItem.createFromResponse(item))
  }

  // <editor-fold desc="Event handlers">
  onNewReservationCreated(reservationItem: MenuReservationItem): void {
    if (this.weeklyReservationCollection) {
      this.weeklyReservationCollection.push(reservationItem)

      this.snackbarColor = 'success'
      this.snackBarMessage = this.$t('orderPage.newReservationCreatedMessage')
      this.showSnackBar = true
      this.fetchWeeklyData(this.isoWeek)
    }
  }

  onReservationChanged(changedItem: MenuReservationItem, stateResult: string): void {
    if (this.weeklyReservationCollection) {
      _.remove(this.weeklyReservationCollection, (item: MenuReservationItem) => item.reservationId === changedItem.reservationId)
      this.weeklyReservationCollection.push(changedItem)

      if (stateResult === 'canceled') {
        this.snackBarMessage = this.$t('orderPage.reservationCanceledMessage')
      } else if (stateResult === 'restored') {
        this.snackBarMessage = this.$t('orderPage.reservationRestoredMessage')
      } else {
        this.snackBarMessage = this.$t('orderPage.reservationChangedMessage')
      }

      this.fetchWeeklyData(this.isoWeek)

      this.snackbarColor = 'success'

      this.showSnackBar = true
    }
  }

  onGroupSelectionChange(groupItem: MenuGroupItem, selection: SubGroupSelectionMap): void {
    this.currentSelection.set(groupItem, selection)
  }

  onBackToCalendarButtonClick(): void {
    this.$router.push({
      name: 'Order',
      params: {
        isoWeek: this.isoWeek
      }
    }).catch((e) => console.debug(e))
  }

  // </editor-fold>

  fixDateIfNeeded(): void {
    if (this.weeklyOfferCollection && this.date) {
      const offerDateCollection = this.weeklyOfferCollection.map((item: DailyMenuOffer) => item.date)
      let foundItem: Date | undefined = offerDateCollection.find((item: Date) => moment(item).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD"))
      let foundDate: string = moment().format('YYYY-MM-DD')
      if(this.currentReservationItem && this.currentReservationItem[0]){
        foundDate = this.currentReservationItem[0].formatedDbDate
      } else if (this.isoWeek !== moment().format('GGGG[W]WW')) {
        foundDate = moment(_.first(offerDateCollection)).format('YYYY-MM-DD')
      }

      if (!offerDateCollection.includes(this.date as unknown as Date)) {
        this.$router.replace({
          name: 'Order',
          params: {
            isoWeek: this.isoWeek,
            date: foundDate
          }
        }).catch(() => {
        })
      }
    }
  }

  async fetchConfiguration():Promise<void>{
    const payload: any = this.currentUser.business.id
    try {
      this.configuration = await this.piniaStore.fetchConfigurationGroups(payload)
    } catch (e) {
      this.showSnackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    }
  }

  async fetchSettingsData(): Promise<void> {
    try {
      this.settingsData = await this.$store.dispatch(FETCH_TENANT_NAME)
    } catch (e) {
    } finally {
    }
  }

  async fetchCustomerSettings(): Promise<void> {
    const payload: any = this.currentUser.tenant.code
    try {
      this.customersettingsData = await this.$store.dispatch(FETCH_CUSTOMER_DATA,payload)
      this.customerConfiguration = this.customersettingsData[0].configuration.allow_cross_top_menu_group
    } catch (e) {
    } finally {
    }
  }

  async created() {
    await this.fetchCustomerSettings()
  }

  mounted() {
    this.fetchWeeklyData(this.isoWeek)
    this.fetchSettingsData()
    this.fetchConfiguration()
  }

  beforeRouteEnter(to: Route, from: Route, next: Function): void {
    redirectIfNeeded(to, next)
  }

  beforeRouteUpdate(to: Route, from: Route, next: Function): void {
    redirectIfNeeded(to, next)
  }
}
</script>

<style lang="stylus" scoped>

.style-col{
  position fixed
  bottom 20px
  left 100px

}
.header {
  text-transform: capitalize;
  background: url('../assets/1.0-single-image-banner-block-1700x385px.jpg') center center;
  height: 68px
}

</style>
